import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoClose } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import logo from "../assets/logo/logo.png";
import { MdAccountCircle } from "react-icons/md";

function Navbar() {

    const [isVisible, setIsVisible] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [menuTransition, setMenuTransition] = useState(false);
    const [hideLink, setHideLink] = useState(false);
    const [negativeClass, setNegativeClass] = useState('text-negative');

    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    let lastScrollY = window.scrollY;
    
    useEffect(() => {
        const handleScroll = () => {
            const isSmallDevice = window.innerWidth < 768;
            if (!isMenuOpen) {
                setIsVisible(window.scrollY < lastScrollY);
                lastScrollY = window.scrollY;
            }

            if (window.scrollY < 800) {
                setIsVisible(true)
            }
            
            if ((window.scrollY > 850 && !isSmallDevice) || (window.scrollY > 710 && isSmallDevice)) {
                setNegativeClass('text-negative');
            } else {
                // setNegativeClass('text-negative-remove');
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => window.removeEventListener('scroll', handleScroll);
    }, [isMenuOpen]);

    useEffect(() => {
        document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto';
    }, [isMenuOpen]);


    const handleMenuOpen = () => {
        setIsMenuOpen(true);
        setHideLink(false);
        setTimeout(() => {
            setMenuTransition(true);
        }, 500);
    };

    const handleMenuClose = () => {
        setHideLink(true);
        setTimeout(() => {
            setMenuTransition(false);
            setIsMenuOpen(false);
        }, 450);
    };

    return (
    <>
     {/* <div className={`fixed z-50 top-0 left-0 w-full transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
            <div className={`flex xl:justify-center justify-end items-center`}>
                <div className="hidden xl:block">
                    <nav className="flex justify-end text-white items-center bg-slate-200 p-5 rounded-3xl mt-5 shadow-2xl glassmorphism-white">
                        <Link to="/" className={`uppercase panoragraf-light  mx-6 ${isActive('/') ? 'underline-animate-active' : 'underline-animate'}`}>Home</Link>
                        <Link to="/staff/" className={`uppercase panoragraf-light  mx-6 ${isActive('/staff/') ? 'underline-animate-active' : 'underline-animate'}`}>Chi siamo</Link>
                        <Link to="/fisioterapia/" className={`uppercase panoragraf-light  mx-6 ${isActive('/fisioterapia/') ? 'underline-animate-active' : 'underline-animate'}`}>fisioterapia</Link>
                        <Link to="/formazione/" className={`uppercase panoragraf-light  mx-6 ${isActive('/formazione/') ? 'underline-animate-active' : 'underline-animate'}`}>formazione</Link>
                        <Link to="/tecnologie/" className={`uppercase panoragraf-light  mx-6 ${isActive('/tecnologie/') ? 'underline-animate-active' : 'underline-animate'}`}>tecnologie</Link>
                    </nav>
                </div>
            </div>
        </div>
        <div className={`block xl:hidden fixed z-50 top-0 left-0 w-full transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
            <div className={`flex xl:justify-center justify-end items-center text-slate-50 p-10`}>
                <div className="">
                    <button className="w-6 h-6" onClick={handleMenuOpen}>
                        <div className=''><RxHamburgerMenu className='text-3xl text-gold'/></div>
                    </button>
                    <nav className={`z-50 flex flex-col justify-top items-center absolute top-0 right-0 w-full h-full bg-black transition-all duration-[500ms] ease-in ${isMenuOpen ? 'opacity-100' : 'opacity-0'} ${isMenuOpen ? 'translate-y-0' : '-translate-y-full'} ${isMenuOpen && 'h-screen'}`}>
                        {menuTransition && (
                            <>
                                <Link to="/" data-aos="fade-right" data-aos-duration="250" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 mb-2 mt-36 ${isActive('/') ? 'text-gold' : ''}`}>Home</Link>
                                <Link to="/staff/" data-aos="fade-right" data-aos-duration="500" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/staff/') ? 'text-gold' : ''}`}>chi siamo</Link>
                                <Link to="/fisioterapia/" data-aos="fade-right" data-aos-duration="750" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/fisioterapia/') ? 'text-gold' : ''}`}>fisioterapia</Link>
                                <Link to="/formazione/" data-aos="fade-right" data-aos-duration="1000" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/formazione/') ? 'text-gold' : ''}`}>Formazione</Link>
                                <Link to="/tecnologie/" data-aos="fade-right" data-aos-duration="1000" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/tecnologie/') ? 'text-gold' : ''}`}>Tecnologie</Link>
                                <button className="absolute top-0 right-0 w-6 h-6 text-white m-10" onClick={handleMenuClose}>
                                    <IoClose className='text-3xl text-gold'/>
                                </button>
                            </>
                        )}
                    </nav>
                </div>
            </div>
        </div> */}
        <div className={`${negativeClass} fixed z-50 top-0 left-0 w-full transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
            <div className={`flex xl:justify-center justify-end items-center p-10`}>
                <div className="hidden xl:block">
                    <nav className="flex justify-end items-center">
                        <Link to="/" className={`uppercase panoragraf-light font-bold mx-6 ${isActive('/') ? 'underline-animate-active' : 'underline-animate'}`}>Home</Link>
                        <Link to="/staff/" className={`uppercase panoragraf-light font-bold mx-6 ${isActive('/staff/') ? 'underline-animate-active' : 'underline-animate'}`}>Chi siamo</Link>
                        <Link to="/fisioterapia/" className={`uppercase panoragraf-light font-bold mx-6 ${isActive('/fisioterapia/') ? 'underline-animate-active' : 'underline-animate'}`}>fisioterapia</Link>
                        <Link to="/formazione/" className={`uppercase panoragraf-light font-bold mx-6 ${isActive('/formazione/') ? 'underline-animate-active' : 'underline-animate'}`}>formazione</Link>
                        <Link to="/tecnologie/" className={`uppercase panoragraf-light font-bold mx-6 ${isActive('/tecnologie/') ? 'underline-animate-active' : 'underline-animate'}`}>tecnologie</Link>
                        <Link to="/servizi/" className={`uppercase panoragraf-light font-bold mx-6 ${isActive('/servizi/') ? 'underline-animate-active' : 'underline-animate'}`}>servizi</Link>
                    </nav>
                </div>
            </div>
        </div>
        <div className={`block xl:hidden fixed z-50 top-0 left-0 w-full transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
            <div className={`flex xl:justify-center justify-end items-center text-slate-50 p-10`}>
                <div className="">
                    <button className="w-6 h-6" onClick={handleMenuOpen}>
                        <div className=''><RxHamburgerMenu className='text-3xl text-gold'/></div>
                    </button>
                    <nav className={`z-50 flex flex-col justify-top items-center absolute top-0 right-0 w-full h-full bg-black transition-all duration-[500ms] ease-in ${isMenuOpen ? 'opacity-100' : 'opacity-0'} ${isMenuOpen ? 'translate-y-0' : '-translate-y-full'} ${isMenuOpen && 'h-screen'}`}>
                        {menuTransition && (
                            <>
                                <Link to="/" data-aos="fade-right" data-aos-duration="250" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 mb-2 mt-36 ${isActive('/') ? 'text-mcare' : ''}`}>Home</Link>
                                <Link to="/staff/" data-aos="fade-right" data-aos-duration="500" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/staff/') ? 'text-mcare' : ''}`}>chi siamo</Link>
                                <Link to="/fisioterapia/" data-aos="fade-right" data-aos-duration="750" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/fisioterapia/') ? 'text-mcare' : ''}`}>fisioterapia</Link>
                                <Link to="/formazione/" data-aos="fade-right" data-aos-duration="1000" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/formazione/') ? 'text-mcare' : ''}`}>Formazione</Link>
                                <Link to="/tecnologie/" data-aos="fade-right" data-aos-duration="1000" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/tecnologie/') ? 'text-mcare' : ''}`}>Tecnologie</Link>
                                <Link to="/servizi/" data-aos="fade-right" data-aos-duration="1000" className={`${hideLink ? 'link-hidden' : ''} text-slate-50 uppercase mx-6 my-2 ${isActive('/servizi/') ? 'text-mcare' : ''}`}>Servizi</Link>
                                <button className="absolute top-0 right-0 w-6 h-6 text-white m-10" onClick={handleMenuClose}>
                                    <IoClose className='text-3xl text-mcare'/>
                                </button>
                            </>
                        )}
                    </nav>
                </div>
            </div>
        </div>
    </>
    );
}

export default Navbar;
